/**
 * Operation name of layer.sublayer.query.gql; the sublayer mutations refetch
 * it because StudioLayer has no cache id, so the returned parent does not
 * update the query result on its own.
 */
export const LAYER_SUBLAYER_QUERY_NAME = "LayerSublayerQuery"

/**
 * Sublayers are edited in the catalog environment the backoffice authors:
 * 'dev'. The 'prod' rows only change through a promote, like the parent.
 */
export const LAYER_SUBLAYER_EDIT_ENVIRONMENT = "dev"
